((document) => {
    const disableAnchor = function (e: MouseEvent) {
        if (e.ctrlKey || e.shiftKey || e.metaKey || e.button === 1) {
            return; // don't disable if opening new tab
        }

        const a = e.currentTarget as HTMLAnchorElement;
        if (a.dataset.clicked) {
            e.preventDefault();
            return false;
        }

        if (a.dataset.confirm && !confirm(a.dataset.confirm)) {
            e.preventDefault();
            return false;
        }

        if (a.dataset.spin != 'false') {
            a.style.display = 'inline-block';
            a.style.width = a.clientWidth + 'px';
            a.innerHTML = "<i class='fas fa-fw fa-circle-notch fa-spin'></i>";
            a.classList.add("disabled");
        }

        a.dataset.clicked = "true";
        return true;
    }

    const anchors = document.getElementsByTagName("a");

    for (let i = 0; i < anchors.length; i++) {
        anchors[i].addEventListener("click", disableAnchor)
    }
})(document);